/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Event_State_Start_Time_DInputs */

const en_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starts in ${i?.day}d`)
};

const ar_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يبدأ بعد ${i?.day} ي`)
};

const de_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Startet in ${i?.day} T.`)
};

const es_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comienza en ${i?.day}d`)
};

const fr_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commence dans ${i?.day}j`)
};

const it_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia tra ${i?.day}g`)
};

const ja_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}日後に開始`)
};

const ko_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}일 후 시작`)
};

const pt_br_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começa em ${i?.day}d`)
};

const ru_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начнется через ${i?.day}д`)
};

const th_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มในอีก ${i?.day} วัน`)
};

const tr_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} gün sonra başlıyor`)
};

const zh_cn_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} 天后开始`)
};

const zh_tw_event_state_start_time_d = /** @type {(inputs: Event_State_Start_Time_DInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} 天後開始`)
};

/**
* | output |
* | --- |
* | "Starts in {day}d" |
*
* @param {Event_State_Start_Time_DInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_state_start_time_d = /** @type {((inputs: Event_State_Start_Time_DInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_State_Start_Time_DInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_state_start_time_d(inputs)
	if (locale === "ar") return ar_event_state_start_time_d(inputs)
	if (locale === "de") return de_event_state_start_time_d(inputs)
	if (locale === "es") return es_event_state_start_time_d(inputs)
	if (locale === "fr") return fr_event_state_start_time_d(inputs)
	if (locale === "it") return it_event_state_start_time_d(inputs)
	if (locale === "ja") return ja_event_state_start_time_d(inputs)
	if (locale === "ko") return ko_event_state_start_time_d(inputs)
	if (locale === "pt_br") return pt_br_event_state_start_time_d(inputs)
	if (locale === "ru") return ru_event_state_start_time_d(inputs)
	if (locale === "th") return th_event_state_start_time_d(inputs)
	if (locale === "tr") return tr_event_state_start_time_d(inputs)
	if (locale === "zh_cn") return zh_cn_event_state_start_time_d(inputs)
	return zh_tw_event_state_start_time_d(inputs)
});